import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from 'react-i18next';
import Thumb from './common/Thumb';
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import TaggedImageSlider from './common/TaggedImageSlider';

const Tag = () => {
    async function search(tag,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/tag/",{tag:tag,page:page}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getRandomTagList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/random").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t} = useTranslation()
    // ナビゲーション
    const navigate = useNavigate();
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // タグ検索情報
    const [searchResultList,setSearchResultList] = useState([])
    const [searchPage,setSearchPage] = useState([])
    const [randomTagList,setRandomTagList] = useState([])

    // 検索ワード
    let param = useParams()
    let tag = param.tag
    let page = parseInt(param.page)

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "#" + tag + "の画像 - アワートAI"
        setSearchPage(page)
        search(tag,page).then(json=>{resultSet(json)})
        /*getRandomTagList().then(r => {
            if(r.result){
                setRandomTagList(r.data)
            }
        })*/
    },[tag,page])

    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    })

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 検索結果セット
    function resultSet(json){
        if(json.result){
            setSearchResultList(json.data)
        } else {
            setSearchResultList([])
            setSearchPage(1)
        }
        // スクロールを最上位に戻す
        window.scrollTo({top:0,left:0,behavior:"instant"})
    }

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            <Icon.TagFill style={{paddingBottom:"5px",color:"orange"}} /> {tag === "*" ? t("tag.hashTag") : t("tag.hashTag") + " 「#"+tag+"」"}
            &nbsp;<LinkContainer to={"/odai"}><Button variant='outline-secondary'>{t("category.odai")}</Button></LinkContainer>
        </Container>
        <Container>{randomTagList.map((d,i) => {
            return <Button variant="outline-primary" className='m-2' onClick={() => navigate("/tag/"+d.tag+"/1")} key={i}>{d.tag}</Button>
        })}</Container>
        <div>
            <TaggedImageSlider />
        </div>
        <Container className='d-flex p-0'>
            <Row>
                <Col xs={8} sm={8} md={7} lg={7} xl={7} xxl={7} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onClick={(e) => {
                            updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setOmitContinuous(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={8} sm={8} md={5} lg={5} xl={5} xxl={5} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        {tileMode ? (
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {searchResultList.map((data,i) => {
                    if(i === 31){
                        return ""
                    }
                    if(omitContinuous && i > 0 && searchResultList[i-1].user_id === data.user_id){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} list={searchResultList} listName={"#" + tag} />

                })}
            </Masonry>
        ) : (
        <div className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {searchResultList.map((data,i) => {
                if(i === 31){
                    return ""
                }
                if(omitContinuous && i > 0 && searchResultList[i-1].user_id === data.user_id){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
            return <Thumb data={data} i={i} dialog={dialog} key={i} list={searchResultList} listName={"#" + tag} />
            })}
        </div>
        )}
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <Button onClick={() => {
                        let tag = param.tag
                        let page = searchPage - 1
                        setSearchPage(page)
                        navigate("/tag/" + tag + "/" + page)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {searchResultList.length > 12 ? (
                    <Button onClick={() => {
                        let tag = param.tag
                        let page = searchPage + 1
                        setSearchPage(page)
                        navigate("/tag/" + tag + "/" + page)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
        </Container>
        <Footer />
    </div>
    )
}

export default Tag;
